import { convertPrice } from '@/utils/common'
const BASE_TH_STYLE = { fontWeight: 600, color: '#181c32', textAlign: 'center' }

export const STORE_TABLE_FIELDS = [
  {
    key: 'count',
    label: 'STT',
    thStyle: { fontWeight: 600, color: '#181c32', width: '5%' },
    tdClass: 'text-center',
  },
  {
    key: 'siteCode',
    label: 'Sitecode',
    thStyle: { fontWeight: 600, color: '#181c32', width: '25%' },
    tdClass: 'text-left',
  },
  {
    key: 'name',
    label: 'Tên cửa hàng',
    thStyle: { fontWeight: 600, color: '#181c32', width: '40%' },
    tdClass: 'text-left',
  },
  {
    key: 'targetQuantity',
    label: 'Chỉ tiêu',
    thStyle: { fontWeight: 600, color: '#181c32', width: '15%' },
    tdClass: 'text-left',
  },
  {
    key: 'achieved',
    label: 'Thực đạt',
    thStyle: { fontWeight: 600, color: '#181c32', width: '15%' },
    tdClass: 'text-right',
  },
  { key: 'actions', label: '', tdClass: 'text-center' },
]

export const PRODUCT_TABLE_FIELDS = [
  {
    key: 'count',
    label: 'STT',
    thStyle: {
      ...BASE_TH_STYLE,
      width: '2%',
    },
    tdClass: 'text-center',
  },
  {
    key: 'productName',
    label: 'Sản phẩm',
    thStyle: {
      ...BASE_TH_STYLE,
      width: '18%',
    },
    tdClass: 'text-left',
  },
  {
    key: 'discountPolicyType',
    label: 'Hình thức',
    thStyle: {
      ...BASE_TH_STYLE,
      width: '5%',
    },
    tdClass: 'text-center',
  },
  {
    key: 'discountAmount',
    label: 'Mức hỗ trợ',
    thStyle: {
      ...BASE_TH_STYLE,
      width: '15%',
    },
    tdClass: 'text-left',
  },
  {
    key: 'targetQuantity',
    label: 'Chỉ tiêu',
    thStyle: {
      ...BASE_TH_STYLE,
      width: '15%',
    },
    tdClass: 'text-left',
  },
  {
    key: 'achieved',
    label: 'Thực đạt',
    thStyle: {
      ...BASE_TH_STYLE,
      width: '7%',
    },
    tdClass: 'text-right',
  },
  {
    key: 'achievedRatio',
    label: 'Tỉ lệ',
    tdClass: 'text-right',
    thStyle: { ...BASE_TH_STYLE, width: '5%' },
  },
  {
    key: 'supportedNumber',
    label: 'SL hỗ trợ',
    tdClass: 'text-right',
    thStyle: { ...BASE_TH_STYLE, width: '5%' },
  },
  {
    key: 'supportedAmount',
    label: 'Thành tiền',
    tdClass: 'text-right',
    thStyle: { ...BASE_TH_STYLE, width: '10%' },
  },
  {
    key: 'imeiDetails',
    label: 'IMEI',
    tdClass: 'text-center',
    thStyle: { ...BASE_TH_STYLE, width: '3%' },
  },
  {
    key: 'actions',
    label: '',
    tdClass: 'text-center',
    thStyle: { ...BASE_TH_STYLE, width: '3%' },
  },
]

export const CATEGORY_TABLE_FIELDS = [
  {
    key: 'count',
    label: 'STT',
    thStyle: {
      ...BASE_TH_STYLE,
      width: '3%',
    },
    tdClass: 'text-center',
  },
  {
    key: 'categoryName',
    label: 'Danh mục',
    thStyle: {
      ...BASE_TH_STYLE,
      width: '25%',
    },
    tdClass: 'text-left',
  },
  {
    key: 'discountPolicyType',
    label: 'Hình thức',
    thStyle: {
      ...BASE_TH_STYLE,
      width: '5%',
    },
    tdClass: 'text-left',
  },
  {
    key: 'discountAmount',
    label: 'Mức hỗ trợ',
    thStyle: {
      ...BASE_TH_STYLE,
      width: '15%',
    },
    tdClass: 'text-left',
  },
  {
    key: 'targetQuantity',
    label: 'Chỉ tiêu',
    thStyle: {
      ...BASE_TH_STYLE,
      width: '15%',
    },
    tdClass: 'text-left',
  },
  {
    key: 'achieved',
    label: 'Thực đạt',
    thStyle: {
      ...BASE_TH_STYLE,
      width: '8%',
    },
    tdClass: 'text-right',
  },
  {
    key: 'achievedRatio',
    label: 'Tỉ lệ',
    tdClass: 'text-right',
    thStyle: { ...BASE_TH_STYLE, width: '6%' },
  },
  {
    key: 'supportedNumber',
    label: 'SL hỗ trợ',
    tdClass: 'text-right',
    thStyle: { ...BASE_TH_STYLE, width: '6%' },
  },
  {
    key: 'supportedAmount',
    label: 'Thành tiền',
    tdClass: 'text-right',
    thStyle: { ...BASE_TH_STYLE, width: '10%' },
  },
  {
    key: 'imeiDetails',
    label: 'IMEI',
    tdClass: 'text-center',
    thStyle: { ...BASE_TH_STYLE, width: '3%' },
  },
  {
    key: 'actions',
    label: '',
    tdClass: 'text-center',
    thStyle: { ...BASE_TH_STYLE, width: '3%' },
  },
]

export const IMEI_TABLE_FIELDS = [
  {
    key: 'index',
    label: 'STT',
    tdClass: 'text-center',
    thStyle: { fontWeight: 600, color: '#181c32', width: '5%', textAlign: 'center' },
  },
  {
    key: 'imeiCode',
    label: 'IMEI',
    tdClass: 'text-left',
    thStyle: { fontWeight: 600, color: '#181c32', width: '20%', textAlign: 'center' },
  },
  {
    key: 'date',
    label: 'Thông tin',
    tdClass: 'text-left',
    thStyle: { fontWeight: 600, color: '#181c32', width: '25%', textAlign: 'center' },
  },
  {
    key: 'activeDate',
    label: 'Ngày kích hoạt',
    tdClass: 'text-center',
    thStyle: { fontWeight: 600, color: '#181c32', width: '15%', textAlign: 'center' },
  },
  {
    key: 'sourceFromName',
    label: 'Nguồn',
    tdClass: 'text-center',
    thStyle: { fontWeight: 600, color: '#181c32', width: '20%', textAlign: 'center' },
    sortable: true,
  },
]

export const DEALSHEET_LIST_FIELDS = [
  {
    key: 'checkbox',
    label: '',
    sortable: false,
    thStyle: {
      fontWeight: 600,
      color: '#181c32',
      width: '3%',
      textAlign: 'center',
    },
    tdClass: 'text-center',
  },
  {
    key: 'code',
    label: 'Mã',
    sortable: false,
    thStyle: {
      fontWeight: 600,
      color: '#181c32',
      width: '10%',
      textAlign: 'center',
    },
  },
  {
    key: 'name',
    label: 'Tên chương trình',
    sortable: false,
    thStyle: {
      fontWeight: 600,
      color: '#181c32',
      width: '25%',
      textAlign: 'center',
    },
  },
  {
    key: 'targetType',
    label: 'Loại',
    sortable: false,
    thStyle: {
      fontWeight: 600,
      color: '#181c32',
      width: '10%',
      textAlign: 'center',
    },
  },
  {
    key: 'targetMin',
    label: 'Min(%)',
    sortable: false,
    thStyle: {
      fontWeight: 600,
      color: '#181c32',
      width: '5%',
      textAlign: 'center',
    },
    tdClass: 'text-right',
  },
  {
    key: 'targetMax',
    label: 'Max(%)',
    sortable: false,
    thStyle: {
      fontWeight: 600,
      color: '#181c32',
      width: '5%',
      textAlign: 'center',
    },
    tdClass: 'text-right',
  },
  {
    key: 'startDate',
    label: 'Ngày bắt đầu',
    sortable: false,
    thStyle: {
      fontWeight: 600,
      color: '#181c32',
      width: '10%',
      textAlign: 'center',
    },
  },
  {
    key: 'endDate',
    label: 'Ngày kết thúc',
    sortable: false,
    thStyle: {
      fontWeight: 600,
      color: '#181c32',
      width: '10%',
      textAlign: 'center',
    },
  },
  {
    key: 'progress',
    label: 'Tiến độ',
    sortable: false,
    thStyle: {
      fontWeight: 600,
      color: '#181c32',
      width: '10%',
      textAlign: 'center',
    },
    tdClass: 'text-right',
  },
  {
    key: 'totalDetailAchieved',
    label: 'Tổng đã đạt',
    sortable: false,
    thStyle: {
      fontWeight: 600,
      color: '#181c32',
      width: '10%',
      textAlign: 'center',
    },
    tdClass: 'text-right',
  },
  {
    key: 'isActiveName',
    label: 'Trạng thái',
    sortable: false,
    thStyle: {
      fontWeight: 600,
      color: '#181c32',
      width: '7%',
      textAlign: 'center',
    },
  },
  {
    key: 'createdByName',
    label: 'Người tạo',
    sortable: false,
    thStyle: {
      fontWeight: 600,
      color: '#181c32',
      width: '10%',
      textAlign: 'center',
    },
  },
  { key: 'actions', label: '', width: '10%' },
]

export const DEALSHEET_LIST_EXPIRE_FIELDS = [
  {
    key: 'dealsheetId',
    label: 'ID',
    sortable: false,
    thStyle: { fontWeight: 600, color: '#181c32', width: '5%' },
  },
  {
    key: 'code',
    label: 'Mã',
    sortable: false,
    thStyle: { fontWeight: 600, color: '#181c32', width: '15%' },
  },
  {
    key: 'startDate',
    label: 'Ngày bắt đầu',
    sortable: false,
    thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
  },
  {
    key: 'endDate',
    label: 'Ngày kết thúc',
    sortable: false,
    thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
  },
  {
    key: 'targetMin',
    label: 'ĐK min',
    sortable: false,
    thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
    tdClass: 'text-right',
  },
  {
    key: 'productName',
    label: 'Tên sản phẩm',
    sortable: false,
    thStyle: { fontWeight: 600, color: '#181c32' },
    tdClass: 'text-left',
  },
  {
    key: 'categoryName',
    label: 'Tên danh mục',
    sortable: false,
    thStyle: { fontWeight: 600, color: '#181c32' },
    tdClass: 'text-left',
  },
  {
    key: 'achievedRatio',
    label: 'Thực đạt',
    sortable: false,
    thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
    tdClass: 'text-right',
  },
]
